import React, { useContext, useState } from 'react';

type OnBackType = (() => void) | null;

interface Value {
  onBack: OnBackType;
  setOnBack: (callback: () => void) => void;
  backBarContent: React.ReactNode;
  setBackBarContent: (content: React.ReactNode) => void;
}

const BackBarContext = React.createContext({} as Value);
export const useBackBarStore = () => useContext(BackBarContext);

export const BackBarStoreContextProvider = ({ children }) => {
  const [onBack, setOnBack] = useState<OnBackType>(null);
  const [backBarContent, setBackBarContent] = useState<React.ReactNode>(null);

  return (
    <BackBarContext.Provider
      value={{
        onBack,
        // https://stackoverflow.com/a/55621679
        setOnBack: (callback: OnBackType) => setOnBack(() => callback),
        backBarContent,
        setBackBarContent,
      }}
    >
      {children}
    </BackBarContext.Provider>
  );
};
